import { useState } from 'react';
import { motion } from 'framer-motion';
import { TREATMENTS } from './data';
// TREATMENTS — list as medical-spec records, NOT card grid.
export default function Treatments({ setPage }) {
  const cats = ['All', ...new Set(TREATMENTS.map(t => t.cat))];
  const [c, setC] = useState('All');
  const list = c === 'All' ? TREATMENTS : TREATMENTS.filter(t => t.cat === c);
  return (
    <div className="bg-[#F8FAFB] text-[#0A2E3C]">
      <section className="pt-12 pb-8 max-w-[1500px] mx-auto px-8 lg:px-14 border-b border-[#1B7A8C]/15">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#1B7A8C] mb-3">⊕ Section II / Treatments</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.92]">Plain prices, <span className="italic text-[#1B7A8C]">explained</span>.</h1>
      </section>

      <div className="border-b border-[#1B7A8C]/15 bg-white sticky top-16 z-30">
        <div className="max-w-[1500px] mx-auto px-8 lg:px-14 py-3 flex flex-wrap gap-2 font-mono text-[10px] tracking-[0.22em] uppercase">
          <span className="text-[#0A2E3C]/45 mr-2 self-center">Filter</span>
          {cats.map(cat => (
            <button key={cat} onClick={() => setC(cat)} data-testid={`dent-cat-${cat}`}
              className={`px-3 py-1.5 transition-colors ${c === cat ? 'bg-[#1B7A8C] text-white' : 'border border-[#1B7A8C]/20 text-[#0A2E3C]/65 hover:border-[#1B7A8C]'}`}>{cat}</button>
          ))}
        </div>
      </div>

      <section className="max-w-[1300px] mx-auto px-8 lg:px-14 py-12 space-y-3">
        {list.map((t, i) => (
          <motion.article key={t.code} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ delay: i * 0.04 }}
            className="bg-white border border-[#1B7A8C]/15 p-6 lg:p-8 grid lg:grid-cols-[100px_1fr_auto] gap-6 items-baseline hover:border-[#E08672] transition-colors">
            <div>
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#1B7A8C]">{t.code}</p>
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#0A2E3C]/45 mt-1 bg-[#7DC3D1]/15 px-2 py-0.5 inline-block">{t.cat}</p>
            </div>
            <div>
              <h3 className="font-serif text-xl lg:text-2xl leading-tight" dangerouslySetInnerHTML={{ __html: t.t }} />
              <p className="text-sm text-[#0A2E3C]/65 mt-2 leading-[1.65]" dangerouslySetInnerHTML={{ __html: t.d }} />
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#E08672] mt-3">⏱ {t.dur}</p>
            </div>
            <div className="text-right">
              <p className="font-serif text-3xl text-[#1B7A8C]">{t.from}</p>
              <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#0A2E3C]/45 mt-1">From</p>
              <button onClick={() => setPage('book')} className="mt-3 font-mono text-[10px] tracking-[0.3em] uppercase border-b border-[#E08672] text-[#E08672] pb-0.5 hover:text-[#1B7A8C] hover:border-[#1B7A8C]">Book →</button>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
